
export async function LoginHelper(data) {
    try {
        const response = await fetch(`${process.env.REACT_APP_CRM_ENDPOINT_URL}/en/api/v1.0/KetQuaCdha/login-customer`, {
            //const response = await fetch("http://localhost:5000/en/api/v1.0/KetQuaCdha/login-customer", {
            method: "POST", // phương thức
            headers: {
                "Content-Type": "application/json", // định dạng JSON
            },
            body: JSON.stringify({
                userName: data.username,
                passWord: data.password,
                maCoSoKcb: data.maCoSoKcb,
            }), // dữ liệu gửi
        });


        if (!response.ok) {
            console.log("status", response);
            return false;
        }

        const result = await response.json(); // đọc dữ liệu JSON trả về
        return result.data;
    } catch (error) {
        console.error("Lỗi:", error);
    }
}
